export function getAOIds(ao) {
    let aoIds = "";
    ao.forEach((group) => {
        group.data.forEach(({ _id }) => {
            aoIds += _id;
        });
    });
    return aoIds;
}

export function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    return JSON.parse(jsonPayload);
}
export const pauseExecution = (ms) =>
    new Promise((resolve) => setTimeout(resolve, ms));